The icon images to indicate profile existence.
